import { Mail, MailOpen } from "lucide-react";
import {
  notificationTypeLabel,
  readLabel,
  readTone,
  audienceLabel,
  deliveryStatusLabel,
  deliveryStatusTone,
  typeBadgeClass,
  typeIcon,
  snippet,
  wordSnippet,
  formatCreatedAt,
  relativeCreatedAt,
} from "./notificationHelpers";

export function NotificationTypeIcon({ type, size = 20, className = "" }) {
  const Icon = typeIcon(type);
  return (
    <span className={`notif-type-icon ${typeBadgeClass(type)}${className ? ` ${className}` : ""}`}>
      <Icon size={size} strokeWidth={1.8} />
    </span>
  );
}

export function NotificationTypeBadge({ type }) {
  return (
    <span className={`notif-badge notif-badge-type ${typeBadgeClass(type)}`}>
      {notificationTypeLabel(type)}
    </span>
  );
}

export function NotificationAudienceBadge({ sendTo, notification }) {
  return (
    <span className="notif-badge notif-badge-audience">
      {audienceLabel(sendTo, notification)}
    </span>
  );
}

export function NotificationDeliveryBadge({ notification }) {
  const status = notification?.deliveryStatus;
  if (!status) return null;

  return (
    <span className={`notif-badge notif-badge-delivery ${deliveryStatusTone(status)}`}>
      {deliveryStatusLabel(status)}
    </span>
  );
}

export function NotificationReadBadge({ isRead }) {
  return (
    <span className={`notif-badge notif-badge-read ${readTone(isRead)}`}>
      {readLabel(isRead)}
    </span>
  );
}

export function NotificationReadToggle({ isRead, onToggle, disabled = false, compact = false }) {
  return (
    <button
      type="button"
      className={`notif-read-toggle ${readTone(isRead)}${compact ? " is-compact" : ""}`}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        onToggle?.();
      }}
      disabled={disabled}
      title={isRead ? "Mark as unread" : "Mark as read"}
      aria-label={isRead ? "Mark as unread" : "Mark as read"}
    >
      {isRead ? <Mail size={14} /> : <MailOpen size={14} />}
      <span>{readLabel(isRead)}</span>
    </button>
  );
}

export function NotificationTitleCell({
  notification,
  previewMax = 100,
  previewWords = 8,
  emphasizeUnread = true,
}) {
  const unread = emphasizeUnread && !notification?.isRead;
  const preview =
    previewWords != null
      ? wordSnippet(notification?.content, previewWords)
      : snippet(notification?.content, previewMax);
  return (
    <div className="notif-title-cell">
      <NotificationTypeIcon type={notification?.type} size={18} />
      <div className="notif-title-copy">
        <p className={`data-name notif-title${unread ? " is-unread" : ""}`}>
          {notification?.title || "Untitled notification"}
        </p>
        <p className="notif-preview">{preview}</p>
      </div>
    </div>
  );
}

export function NotificationDateCell({ createdAt }) {
  if (!createdAt) return "—";
  return (
    <div className="notif-date-cell">
      <span>{formatCreatedAt(createdAt)}</span>
      <em>{relativeCreatedAt(createdAt)}</em>
    </div>
  );
}
